//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setToken, getToken, clearToken } from '@/common/js/common';
import conf from './../../config/base.js';
export default {
  //   name: routerNames.LoginScan,
  components: {},
  data() {
    return {
      isWechat: ____isWechatBrowser(),
      message: '正在登录...',
      foxReturnUrl: '',
      foxReturnUrl2: '',
      err2: '',
      isDing: ____isDingBrowser(),
      recordNumber: '沪ICP备15034889号-3',
    };
  },
  created() {},
  activated() {
    var $self = this;
    //to.fullPath一般格式是create/index?pl=app&us=1111,
    //但是经过微信跳转的参数code&state通过fullPath获取不到.../?code=***&state=***/#/create/index?...
    $self.foxReturnUrl = $self.$route.query.foxredirect;
    $self.foxReturnUrl2 = $self.$route.query.foxredirect2;
    var foxQueryJSON = {
      code: $self.getUrlKey($self.foxReturnUrl2, 'code'),
      state: $self.getUrlKey($self.foxReturnUrl2, 'state'),
      pl: $self.getUrlKey($self.foxReturnUrl2, 'pl'),
      us: $self.getUrlKey($self.foxReturnUrl2, 'us'),
      br: $self.getUrlKey($self.foxReturnUrl2, 'br'),
      openId: $self.getUrlKey($self.foxReturnUrl2, 'openId'),
      ut: $self.getUrlKey($self.foxReturnUrl2, 'ut'),
    };
    //登录方式有4种
    //1、URL 直接带Token
    var ut = foxQueryJSON.ut;
    //2、票税助手微信公众号 底部菜单跳转  会带code和state
    //可以通过这2个参数  去服务端获取token
    var code = foxQueryJSON.code;
    var state = foxQueryJSON.state;
    //3、票税助手嵌入商家APP中
    //通过pl(处于app环境中的标识),us(用户的otid)，获取token
    var pl = foxQueryJSON.pl;
    var us = foxQueryJSON.us;
    //4、票税助手嵌入商家 微信公众号或支付宝生活号
    //通过openid去服务端获取token
    var openId = foxQueryJSON.openId;
    //获取集团代码
    var br = foxQueryJSON.br;
    if (br) {
      conf.autoLoginInfo.source = br;
    }
    try {
      $self.err2 = ut + ',' + code + ',' + state + ',' + pl + ',' + us + ',' + openId;
    } catch (error) {
      $self.err2 = error;
    }

    if (ut && ut != '') {
      setToken(encodeURIComponent(ut));
      //window.location页面跳转相关方法在某些安卓浏览器里不生效，使用$router做内部跳转,====app嵌入尽量用内部跳转

      const redirect_url = $self.filterRedirectUrl(['pl=app', 'ut=' + encodeURIComponent(ut)]);
      $self.locationReplace(redirect_url);
      // $self.$router.replace($self.filterRedirectUrlRouter(['pl=app', 'ut=' + encodeURIComponent(ut)]));
      // if (!$self.isWechat) {
      //   //有时候上面的代码并不会执行真正的跳转工作，需要执行一次强制刷新
      //   window.location.reload();
      // }
    } else if (code && code != '' && state.indexOf('_') < 0) {
      var params = {
        s: state,
        c: code,
      };
      $self.$webapi.queryTokenByCode(params).then(res => {
        $self.getTokenCallBack(res, $self.filterRedirectUrl(['code=' + code, 'state=' + state]));
      }).catch(error => {
        $self.message = `code: ${code}; state: ${state}; params: ${JSON.stringify(params)}; error: ${JSON.stringify(error)}`;
      });
    } else if (pl && pl == 'app' && us && us != '') {
      var params = { source: br || 'xfpmer' };
      params.otId = us;
      $self.setSource(br)
      $self.$webapi.queryTokenByOtId(params).then(res => {
        $self.getTokenCallBackForApp(res, $self.filterRedirectUrlRouter(['pl=app', 'us=' + us]));
      }).catch(error => {
        $self.message = `us: ${us}; pl: ${pl}; params: ${JSON.stringify(params)}; error: ${JSON.stringify(error)}`;
      });
    } else if (openId && openId != '') {
      var params = { source: br || 'xfpmer' };
      if (____isAlipayBrowser()) {
        params.otId = openId;
      } else if (____isWechatBrowser()) {
        params.openId = openId;
      }
      $self.$webapi.queryTokenByOtId(params).then(res => {
        $self.getTokenCallBack(res, $self.filterRedirectUrl(['openId=' + openId]));
      }).catch(error => {
        $self.message = `openId: ${openId}; params: ${JSON.stringify(params)}; error: ${JSON.stringify(error)}`;
      });
    } else if ($self.isDing) {
      $self.message = `Loading...`;
      var corpId = $self.getUrlKey($self.foxReturnUrl2, 'corpId');
      var code = '';
      var code1 = '';
      dd.ready(function() {
        dd.runtime.permission.requestAuthCode({
          corpId: corpId, // 企业id
          onSuccess: function(info) {
            code = info.code + '#' + corpId; // 通过该免登授权码可以获取用户身份
            // alert('钉钉corpId：' + corpId);
            // alert('钉钉code：' + info.code);
            // alert('钉钉授权成功！！');
            // localStorage.setItem('userNickName', info.userName);
            // localStorage.setItem('headimgurl', info.url);
            // localStorage.setItem('userId', info.userId);
            // setToken(info.token);
            //{"status":1,"token":"","userId":"","url":"","userName":""}
            var params = {
              c: code,
              s: 'dingding',
            };
            // {code：“code#corpid”,state：“dingding”}
            $self.$webapi.queryTokenByCode(params).then(res => {
              // setToken(res.data.token);
              $self.getTokenCallBack(res, $self.filterRedirectUrl(['corpId', 'corpId=']));
            });
          },
          onFail: function(err) {
            // alert(err);
            $self.message = JSON.stringify(err);
            console.log(err);
          },
        });
      });
    } else {
      $self.message = '没有权限';
    }
  },
  /**计算属性 将状态表中的数据 映射出来*/
  computed: {},
  /**初始化的时候调用  类似于 ready */
  mounted() {
    const currentURL = window.location.href
    if (currentURL.includes('e-fp.cn')) {
      this.recordNumber = '沪ICP备15034889号-4'
    } else if (currentURL.includes('kaifapiao.com')) {
      this.recordNumber = '沪ICP备15034889号-5'
    } else {
      this.recordNumber = '沪ICP备15034889号-3'
    }
  },
  methods: {
    locationReplace(url) {
      if (history.replaceState){
        // alert('history.replaceState');
        history.replaceState(null, document.title, url);
        history.go(0);
      } else {
        try{
          // alert('location.replace');
          location.replace(url);
        }catch (e){
          // alert('location.href');
          window.location.href = url;
        }
      }
    },
    getTokenCallBack(res, redirectUrl) {
      var $self = this;
      if (res.data.status == 1) {
        if (res.data.token) {
          setToken(res.data.token);
          window.location.replace(redirectUrl);
          if (!$self.isWechat) {
            //有时候上面的代码并不会执行真正的跳转工作，需要执行一次强制刷新
            window.location.reload();
          }
        } else {
          $self.message = '没有权限';
        }
      } else {
        $self.message = '没有权限';
      }
    },
    getTokenCallBackForApp(res, redirectUrl) {
      var $self = this;
      if (res.data.status == 1) {
        if (res.data.token) {
          setToken(res.data.token);
          $self.$router.replace(redirectUrl);
        } else {
          $self.message = '没有权限';
        }
      } else {
        $self.message = '没有权限';
      }
    },
    getUrlKey(url, name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(
            /\+/g,
            '%20'
          )
        ) || null
      );
    },
    //清除url中和token有关的参数
    filterRedirectUrl(params) {
      let url = this.foxReturnUrl2;
      if (params instanceof Array && params.length > 0) {
        params.forEach(element => {
          url = url.replace(element + '&', '').replace(element, '');
        });
      }
      // alert(url)
      return url;
    },
    //清除url中和token有关的参数,使用vue-router跳转
    filterRedirectUrlRouter(params) {
      let url = this.foxReturnUrl;
      if (params instanceof Array && params.length > 0) {
        params.forEach(element => {
          url = url.replace(element + '&', '').replace(element, '');
        });
      }
      return url;
    },
    setSource(source){
      localStorage.setItem('source',source)
    }
  },
};
